export default [256, 512, 768, 1024, 1536]
